export default "__VITE_ASSET__Cc_kbSIk__"